import { JackpotLevel } from "./api";
import { IRandomInterval } from "./Context/RandomInterval";
import { ISystemContext } from "./Context/SystemContext";
import { IJackpotDisplay } from "./IJackpotDisplay";
import { JackpotDisplayParams } from "./JackpotDisplayParams";
import { JackpotText } from "./JackpotText";
import { JackPotTextParams } from "./JackPotTextParams";
import { MoneyFormatter } from "./MoneyFormatter";
import { CreateElement, LogGroup, Scale, Size } from "./MyHelpers";
import { FontResource } from "./ResourceManager/FontResource";
import { Resourceful } from "./ResourceManager/Resourceful";
import { ResourceIdentifier } from "./ResourceManager/ResourceIdentifier";
import { IReadOnlyResourceManager, IWriteOnlyResourceManager, LoadingStage, ResourceManager } from "./ResourceManager/ResourceManager";
import { SpriteResource } from "./ResourceManager/SpriteResource";
import { ScreenProtocol, ScreenProtocolScope } from "./ScreenProtocol";
import { Settings } from "./Settings";
import { PickBonusMessages } from "./slot/PickBonus/PickMessage";
import { CanvasSprite } from "./slot/Sprite/CanvasSprite";
import { ZIndex } from "./ZIndex";

export class JackpotDisplayDiamondPot extends  IJackpotDisplay
{
	protected view: HTMLElement = null;
	protected viewSize: Size = null;
	//Creating elements for JP
	//protected jpTitle: HTMLElement = null;
	protected titleImage: HTMLElement = null;
	protected diamondback: HTMLElement = null;
	protected diamondImage: HTMLElement = null;
	//protected diamondvalue: HTMLElement = null;
	//protected diamondText: HTMLElement = null;
	protected rubyback: HTMLElement = null;
	protected rubyImage: HTMLElement = null;
	//protected rubyvalue: HTMLElement = null;
	//protected rubyText: HTMLElement = null;
	protected emeraldback: HTMLElement = null;
	protected emeraldImage: HTMLElement =null;
	protected emeraldvalue: HTMLElement = null;
	protected emeraldText: HTMLElement = null;
	protected sapphireback: HTMLElement = null;
	protected saphireImage: HTMLElement = null;
	protected sapphirevalue: HTMLElement = null;


	protected commonpath: string = null;
	protected basepath: string = null;
	protected jackpot: string = null;

	protected resid: ResourceIdentifier = null;
	protected screenProtocolScope: ScreenProtocolScope = null;
	
	//crea el contenedor como elemento HTMLElement
	//protected jackpotContainer: HTMLElement = null;

	// protected diamondSpriteAnim: CanvasSprite = null;
	// protected diamondLocation: Point = new Point(8,-34);
	protected diamondStartTimer: IRandomInterval = null;

	// protected rubyAnim: CanvasSprite = null;
	// protected rubyLocation: Point = new Point(365,80);
	protected rubyStartTimer: IRandomInterval = null;

	// protected shappireAnim: CanvasSprite = null;
	// protected shappireLocation: Point = new Point(635,920);
	protected shappireStartTimer: IRandomInterval = null;

	// protected emeraldAnim: CanvasSprite = null;
	// protected emeraldLocation: Point = new Point(617,720);
	protected emeraldStartTimer: IRandomInterval = null;

	//LOAD JACKPOT SPRITE
	protected DiamondSpriteJackpot: CanvasSprite ;
	protected RubySpriteJackpot: CanvasSprite ;
	protected EmeraldSpriteJackpot: CanvasSprite ;
	protected SapphireSpriteJackpot: CanvasSprite ;


	protected titleSpriteAnim: CanvasSprite = null;
	protected titleStartTimer: IRandomInterval = null;

	protected screenProtocol:ScreenProtocol = null;

	protected logGroup: LogGroup ;

	protected systemContext: ISystemContext = null;

	protected allJpTimers: IRandomInterval [] = [];

	protected allJpSpriteAnim: CanvasSprite [] = [];

	public constructor(params: JackpotDisplayParams) {
		super(params);

		this.systemContext = params.systemContext.CreateSubContext("JackpotDisplayDiamondPot");

		this.resid = params.resid.Add("JackpotDisplayDiamondPot");
		this.screenProtocolScope = new ScreenProtocolScope("JackpotDisplayDiamondPot");

		this.screenProtocol = params.screenProtocol;
		//this.logGroup.SetSpecificName(this.name);

		//this.commonpath = Settings.ResourcesFolder + "multigame/slot/common/";
		//this.basepath = Settings.ResourcesFolder + "multigame/slot/" + this.name + "/";
		//Ruta de background de los niveles jackpot
		this.jackpot = Settings.ResourcesFolder + "multigame/multigame/img/";

		//this.viewSize = multigameParams.viewSize;
		this.viewSize = params.viewSize;
		this.logGroup= new LogGroup("JackpotDisplayDiamondPot");

		// this would be "view" with jackpot frames
		this.view = CreateElement("div", {
			//classes: [this.resid.ID()],
			style: {
				position: "absolute",
				top: "0px",
				left: "0px",
				width: this.viewSize.Width + "px",
				height: this.viewSize.Height + "px",
				zIndex: ""+ZIndex.JackpotDisplay,
		}});
		this.view.className = this.resid.ID();

		


		this.diamondback = CreateElement("div", {
			id: "diamondBack",
			classes: ["diamondCon"],
			parentToAppend: this.view,
			style: {
				position: "absolute",
				left: Scale.Xpx(8),
				top: Scale.Ypx(0),
		
				// need to get position from image
				width: Scale.Wpx(1906),
				height: Scale.Hpx(350),
			}
		});

		this.rubyback = CreateElement("div", {
			id: "rubyBack",
			classes: [this.resid.ScopedResourceName("ruby")],
			parentToAppend: this.view,
			style:{
				position: "absolute",
				top: Scale.Ypx(351),
				left: Scale.Xpx(317),
				width: Scale.Wpx(1336),
				height: Scale.Hpx(350),
			}
		});
		
		
		
		//Emerald Jackpot
		this.emeraldback = CreateElement("div", {
			id: "emeraldBack",
			classes: [this.resid.ScopedResourceName("emerald")],
			style:
			{
				position: "absolute",
				top: Scale.Ypx(625),
				left:  Scale.Xpx(93),
				width: Scale.Wpx(876),
				height: Scale.Hpx(258),
			}
		});

		//Emerald Value
		this.emeraldvalue = CreateElement("div", {
			id: "emeraldVal",
			classes: [this.resid.ScopedResourceName("emerald")],
			style: {
						
				position: "absolute",
				fontSize: Scale.fhpx(85),
				left: Scale.Xpx(250),
				top: Scale.Ypx(69),
				width: Scale.Wpx(520),
				height: Scale.Hpx(160),

				display:"flex",
				alignItems: "center",
				justifyContent: "center",
				color: "#50c878",
				fontWeight: "bold",
		}});
	
		

		
		//Emerald Image element
		//this.emeraldImage = document.createElement("img");
		//this.emeraldImage.setAttribute("id", "emeralsImg");
		//this.emeraldImage.setAttribute("src", this.jackpot + "emerald_frame.png");
		//this.emeraldImage.style.width= Scale.Wpx(1920);
		//this.emeraldImage.style.height= Scale.Hpx(1080);
		this.emeraldback.appendChild(this.emeraldvalue);
		this.view.appendChild(this.emeraldback);
		//Shappire Jackpot
		this.sapphireback = document.createElement("div");
		this.sapphireback.setAttribute("id", "shappireBack");
		this.sapphireback.classList.add(this.resid.ScopedResourceName("shappire"));
		this.sapphireback.style.position = "absolute";
		this.sapphireback.style.top = Scale.Ypx(625);
		this.sapphireback.style.left = Scale.Xpx(940);
		this.sapphireback.style.width= Scale.Wpx(897);
		this.sapphireback.style.height= Scale.Hpx(234);

		//Shapire Value
		this.sapphirevalue = document.createElement("div");
		this.sapphirevalue.setAttribute("id", "sapphiredVal");
		this.sapphirevalue.classList.add(this.resid.ScopedResourceName("sapphire"));
		this.sapphirevalue.style.position = "absolute";
		//this.sapphirevalue.style.textShadow = "0px 0px 10px black, 0px 0px 20px black";
		this.sapphirevalue.style.fontSize= Scale.fhpx(85);
		this.sapphirevalue.style.left = Scale.Xpx(111);
		this.sapphirevalue.style.top = Scale.Ypx(71);
		this.sapphirevalue.style.width= Scale.Wpx(510);
		this.sapphirevalue.style.height= Scale.Hpx(160);

		this.sapphirevalue.style.display ="flex";
		this.sapphirevalue.style.alignItems = "center";
		this.sapphirevalue.style.justifyContent = "center";
		this.sapphirevalue.style.color = "#0f52ba";
		this.sapphirevalue.style.fontWeight = "bold";
		
	
		


	


			//Shapire Image element
		//this.saphireImage = document.createElement("img");
		//this.saphireImage.setAttribute("id", "shappireImg");
		//this.saphireImage.setAttribute("src", this.jackpot + "sapphire_frame.png");
		//this.saphireImage.style.width= Scale.Wpx(1920);
		//this.saphireImage.style.height= Scale.Hpx(1080);
		this.sapphireback.appendChild(this.sapphirevalue);
		this.view.appendChild(this.sapphireback);




		
		// recieve message from first screen
		//this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.DiamondAnimation.msgname, (m) => this.DiamondAnimation((<PickBonusMessages.DiamondAnimation>m)), this.screenProtocolScope);
		//this.screenProtocol.AddReceiveMessageHandler(PickBonusMessages.JpShowFinish.msgname, (m) => this.JpShowFinish((<PickBonusMessages.JpShowFinish>m)), this.screenProtocolScope);
	}

	
	protected DiamondAnimation(message:PickBonusMessages.DiamondAnimation)
	{
		this.allJpTimers.forEach((anim:IRandomInterval) =>
		{
			anim.Stop();
		});

		if(message.hitJp == 1)
		{
			this.SapphireSpriteJackpot.Start(true);
		}

		if(message.hitJp == 2)
		{
			this.EmeraldSpriteJackpot.Start(true);
		}

		if(message.hitJp == 3)
		{
			this.RubySpriteJackpot.Start(true);
		}

		if(message.hitJp == 4)
		{
			this.DiamondSpriteJackpot.Start(true);
		}
	}

	protected JpShowFinish(message:PickBonusMessages.JpShowFinish)
	{
		this.allJpSpriteAnim.forEach((anim:CanvasSprite) =>
		{
			if(anim.sprite.Running())
			{
				anim.Repeat(false);
				//anim.Start(false);
				// anim.sprite.Stop();
				// anim.sprite.Update();
			}
		});

		this.StartAnimations();
	}

	public override async PrepareResources(loadingStage: LoadingStage,resourceManager: IWriteOnlyResourceManager): Promise<void> {
		// jackpot frames image
		//resourceManager//.Add(new ImageResource(this.jackpot + "background.3.1.png", this.resid.ScopedResourceName("jackpotframes")));
		//resourceManager.Add(new ImageResource(this.jackpot + "diamond_pot_title.png", this.resid.ScopedResourceName("jackpotTitle")));
		//resourceManager.Add(new ImageResource(this.jackpot + "diamond_frame.png", this.resid.ScopedResourceName("jpDiamondMa")));

		//load Sprite Jackpot 

		if (loadingStage != LoadingStage.System) return 
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotSprite/diamond_sprite", this.resid.Add("diamond_sprite"), true, this.logGroup.Add("diamond_sprite"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotSprite/ruby_sprite", this.resid.Add("ruby_sprite"), true, this.logGroup.Add("ruby_sprite"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotSprite/emerald_sprite", this.resid.Add("emerald_sprite"), true, this.logGroup.Add("emerald_sprite"), true));
		resourceManager.Add(new SpriteResource(this.jackpot + "JackpotSprite/sapphire_sprite", this.resid.Add("sapphire_sprite"), true, this.logGroup.Add("sapphire_sprite"), true));


		// here is how you "load" the image
		// resourceManager.Add(new ImageResource(this.jackpot + "diamond_pot_title.png", this.resid.ScopedResourceName("diamond_pot_title")));
		// resourceManager.Add(new ImageResource(this.jackpot + "diamond_frame.png", this.resid.ScopedResourceName("diamond_frame")));
		// resourceManager.Add(new ImageResource(this.jackpot + "ruby_frame.png", this.resid.ScopedResourceName("ruby_frame")));
		// resourceManager.Add(new ImageResource(this.jackpot + "emerald_frame.png", this.resid.ScopedResourceName("emerald_frame")));
		// resourceManager.Add(new ImageResource(this.jackpot + "sapphire_frame.png", this.resid.ScopedResourceName("sapphire_frame")));

		// diamond animation
		// resourceManager.Add(new SpriteResource(this.jackpot + "jackpot_anims/diamond", this.resid.Add("diamond"), true, this.logGroup.Add("diamond"), true));

		// // ruby animation
		// resourceManager.Add(new SpriteResource(this.jackpot + "jackpot_anims/ruby", this.resid.Add("ruby"), true, this.logGroup.Add("ruby"), true));

		// // sapphire animation
		// resourceManager.Add(new SpriteResource(this.jackpot + "jackpot_anims/sapphire", this.resid.Add("sapphire"), true, this.logGroup.Add("sapphire"), true));

		// //Emerald animation
		// resourceManager.Add(new SpriteResource(this.jackpot + "jackpot_anims/emerald", this.resid.Add("emerald"), true, this.logGroup.Add("emerald"), true));
		
	
		this.TitlePrepare(resourceManager);
		//this.jackpotTextMapping[JackpotLevel.Jp4].PrepareResources(resourceManager);
		//this.jackpotTextMapping[JackpotLevel.Jp3].PrepareResources(resourceManager);

		//resourceManager.Add(new FontResource(this.jackpot+"JackpotFont.ttf",this.resid.ScopedResourceName("JackpotFont"),this.view));
		resourceManager.Add(new FontResource(this.jackpot + "fonts/newzone.ttf", this.resid.ScopedResourceName("JackpotFont")));
		
	
	}

	public TitlePrepare(resourceManager: IWriteOnlyResourceManager)
	{
		resourceManager.Add(new SpriteResource(this.jackpot+ "jackpot_anims/title-common", this.resid.Add("title"), true, this.logGroup.Add("title"), true));
	}

	public TitleLoaded(resourceManager: IReadOnlyResourceManager)
	{
		this.titleSpriteAnim = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("title")).sprite, canvasSize: new Size(Scale.X(1920), Scale.Y(400))});
		this.titleSpriteAnim.View().style.position="absolute";
		this.titleSpriteAnim.View().style.bottom="-91px";
		this.view.appendChild(this.titleSpriteAnim.View());
	}

	public override async ResourcesLoaded(loadingStage: LoadingStage,resourceManager: IReadOnlyResourceManager): Promise<void>
	{

		if(loadingStage != LoadingStage.System) return ;
		this.TitleLoaded(resourceManager);


		let jp4TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("White"),
			width: Scale.W(1518),
			height: Scale.H(165),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}

	
		//this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.jackpotTextMapping[JackpotLevel.Jp4] = new JackpotText(jp4TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.left = Scale.Xpx(333);
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.top = Scale.Ypx(150); //84
		this.jackpotTextMapping[JackpotLevel.Jp4].View().style.position = "absolute";
		this.diamondback.appendChild(this.jackpotTextMapping[JackpotLevel.Jp4].View());

		let jp3TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Red"),
			width: Scale.W(934),
			height: Scale.H(137),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}

		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp3] = new JackpotText(jp3TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.left = Scale.Xpx(149);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.top = Scale.Ypx(137);
		this.jackpotTextMapping[JackpotLevel.Jp3].View().style.position = "absolute";
		this.rubyback.appendChild(this.jackpotTextMapping[JackpotLevel.Jp3].View());

		//change font for Emerald and Spahire
		this.sapphirevalue.style.fontFamily=this.resid.ScopedResourceName("JackpotFont");
		this.emeraldvalue.style.fontFamily=this.resid.ScopedResourceName("JackpotFont");
		
		let jp1TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Green"),
			width: Scale.W(520),
			height: Scale.H(97),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}
		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp1] = new JackpotText(jp1TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.left = Scale.Xpx(111);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.top = Scale.Ypx(105);
		this.jackpotTextMapping[JackpotLevel.Jp1].View().style.position = "absolute";
		this.sapphireback.appendChild(this.jackpotTextMapping[JackpotLevel.Jp1].View());

		let jp2TextParams: JackPotTextParams = {
			logGroup: this.logGroup.Add("Blue"),
			width: Scale.W(550),
			height: Scale.H(97),
			color:  "orangered",
			color2: "yellow",
			font: this.resid.ScopedResourceName("JackpotFont"),
			defaultValue: 0,
			stroke : true,
			bold: true,
		}

		//JackpotFont
		this.jackpotTextMapping[JackpotLevel.Jp2] = new JackpotText(jp2TextParams);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.left = Scale.Xpx(250);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.top = Scale.Ypx(105);
		this.jackpotTextMapping[JackpotLevel.Jp2].View().style.position = "absolute";
		this.emeraldback.appendChild(this.jackpotTextMapping[JackpotLevel.Jp2].View());


		//this.diamondback.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("diamond_frame")).CssBackground();
		
		
		this.DiamondSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("diamond_sprite")).sprite, canvasSize: new Size(Scale.X(1900), Scale.Y(400))});
		//this.DiamondSpriteJackpot.Start();
		this.diamondback.appendChild(this.DiamondSpriteJackpot.View());


		//this.rubyback.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("ruby_frame")).CssBackground();
		this.RubySpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("ruby_sprite")).sprite, canvasSize: new Size(Scale.X(1336), Scale.Y(350))});
		//this.RubySpriteJackpot.Start();
		this.rubyback.appendChild(this.RubySpriteJackpot.View());

		
		//this.emeraldback.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("emerald_frame")).CssBackground();
		this.EmeraldSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("emerald_sprite")).sprite, canvasSize: new Size(Scale.X(876), Scale.Y(258))});
		//this.EmeraldSpriteJackpot.Start();
		this.emeraldback.appendChild(this.EmeraldSpriteJackpot.View());


		
		//this.sapphireback.style.backgroundImage = resourceManager.Get<ImageResource>(this.resid.ScopedResourceName("sapphire_frame")).CssBackground();
		this.SapphireSpriteJackpot = new CanvasSprite({sprite: resourceManager.Get<SpriteResource>(this.resid.Add("sapphire_sprite")).sprite, canvasSize: new Size(Scale.X(876), Scale.Y(258))});
		//this.SapphireSpriteJackpot.Start();
		this.sapphireback.appendChild(this.SapphireSpriteJackpot.View());

		this.allJpSpriteAnim.push(this.DiamondSpriteJackpot);
		this.allJpSpriteAnim.push(this.RubySpriteJackpot);
		this.allJpSpriteAnim.push(this.EmeraldSpriteJackpot);
		this.allJpSpriteAnim.push(this.SapphireSpriteJackpot);


		//this.jpTitle.appendChild(this.titleImage);
		//this.view.appendChild(this.jpTitle);

		// this.diamondSpriteAnim = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("diamond")).sprite);


		// // get position from image
		// this.diamondSpriteAnim.View().style.position = "absolute";
		// this.diamondSpriteAnim.View().style.top = this.diamondLocation.x+"px"; //"282px";
		// this.diamondSpriteAnim.View().style.left = this.diamondLocation.y+"px";//  "-34px";
		// this.diamondSpriteAnim.View().style.zIndex = "4";
		//HIDE 
		//this.view.appendChild(this.diamondSpriteAnim.View()); // puts animation on screen, just like any other element
	

		// this.rubyAnim = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("ruby")).sprite);

		// // get position from image
		// this.rubyAnim.View().style.position = "absolute";
		// this.rubyAnim.View().style.top = this.rubyLocation.x+"px";  //"607px";
		// this.rubyAnim.View().style.left = this.rubyLocation.y+"px";  //"80px";
		// this.rubyAnim.View().style.zIndex = "4";

		//HIDE 
		//this.view.appendChild(this.rubyAnim.View()); // puts animation on screen, just like any other element
		
		//this.rubyAnim.Start(false); //starts animation

		
		// this.shappireAnim = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("sapphire")).sprite);

		// // get position from image
		// this.shappireAnim.View().style.position = "absolute";
		// this.shappireAnim.View().style.top = this.shappireLocation.x+"px";  //"860px";
		// this.shappireAnim.View().style.left = this.shappireLocation.y+"px"; //"920px";
		// this.shappireAnim.View().style.zIndex = "4";
		// //HIDE 
		//this.view.appendChild(this.shappireAnim.View()); // puts animation on screen, just like any other element
		
		// this.emeraldAnim = new CanvasSprite(resourceManager.Get<SpriteResource>(this.resid.Add("emerald")).sprite);

		// // get position from image
		// this.emeraldAnim.View().style.position = "absolute";
		// this.emeraldAnim.View().style.top = this.emeraldLocation.x+"px";  //"870px";
		// this.emeraldAnim.View().style.left = this.emeraldLocation.y+"px";  //"720px";
		// this.emeraldAnim.View().style.zIndex = "4";

		//HIDE 
		//this.view.appendChild(this.emeraldAnim.View()); // puts animation on screen, just like any other element

		

		// repeat at random intervals winthin 5 to 10 seconds
		this.diamondStartTimer = this.systemContext.TimingContext().CreateRandomInterval("diamondStartTimer", 10000,30000, () => this.DiamondSpriteJackpot.Start(false));
		this.rubyStartTimer = this.systemContext.TimingContext().CreateRandomInterval("rubyStartTimer", 10000, 30000, () => this.RubySpriteJackpot.Start(false));
		this.shappireStartTimer = this.systemContext.TimingContext().CreateRandomInterval("shappireStartTimer", 10000, 30000, () => this.SapphireSpriteJackpot.Start(false));
		this.emeraldStartTimer = this.systemContext.TimingContext().CreateRandomInterval("emeraldStartTimer", 10000, 30000, () => this.EmeraldSpriteJackpot.Start(false));
		this.titleStartTimer = this.systemContext.TimingContext().CreateRandomInterval("titleStartTimer", 10000, 30000, () => this.titleSpriteAnim.Start(false));

		this.allJpTimers.push(this.diamondStartTimer);
		this.allJpTimers.push(this.rubyStartTimer);
		this.allJpTimers.push(this.shappireStartTimer);
		this.allJpTimers.push(this.emeraldStartTimer);

		this.StartAnimations();

		this.Update();

		this.jackpotTextMapping[JackpotLevel.Jp4].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp4].Start();

		this.jackpotTextMapping[JackpotLevel.Jp3].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp3].Start();

		this.jackpotTextMapping[JackpotLevel.Jp1].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp1].Start();

		this.jackpotTextMapping[JackpotLevel.Jp2].ResourcesLoaded();
		this.jackpotTextMapping[JackpotLevel.Jp2].Start();
	} 

	// deleted too much, this is how this particular game gets displayed to screen,
	// just returns its own div element
	public View(): HTMLElement {
		return this.view;
	}

	// if we need to update any animation...
	public Update(): void {
		// animation needs to be updated for frames to go forward
		// this.diamondSpriteAnim.Update();
		// this.rubyAnim.Update();
		// this.shappireAnim.Update();
		// this.emeraldAnim.Update();
		this.titleSpriteAnim.Update();
		this.jackpotTextMapping[JackpotLevel.Jp4].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp3].Draw();
		//Change STYLE JP1 and JP2
		this.jackpotTextMapping[JackpotLevel.Jp1].Draw();
		this.jackpotTextMapping[JackpotLevel.Jp2].Draw();
		//UPDATE JACKPOT ANIM

		
		this.DiamondSpriteJackpot.Update();
		this.RubySpriteJackpot.Update();
		this.EmeraldSpriteJackpot.Update();
		this.SapphireSpriteJackpot.Update();
	}

	public StopAnimations(): void {
		// stop animations and their timer to startup in near future

		// if (this.diamondSpriteAnim != null) this.diamondSpriteAnim.Stop();
		// this.diamondStartTimer.Stop();

		// if (this.rubyAnim != null) this.rubyAnim.Stop();
		// this.rubyStartTimer.Stop();

		// if (this.shappireAnim != null) this.shappireAnim.Stop();
		// this.shappireStartTimer.Stop();

		// if (this.emeraldAnim != null) this.emeraldAnim.Stop();
		// this.emeraldStartTimer.Stop();

		if (this.titleSpriteAnim != null) this.titleSpriteAnim.Stop();
		this.titleStartTimer.Stop();
	}

	public StartAnimations(): void {

		//start within 5 seconds
		if (this.DiamondSpriteJackpot != null)
		{
			this.diamondStartTimer.Start();
		}
		
		if (this.RubySpriteJackpot != null)
		{
			this.rubyStartTimer.Start();
		}

		if (this.SapphireSpriteJackpot != null)
		{
			this.shappireStartTimer.Start()
		}

		if (this.EmeraldSpriteJackpot != null)
		{
			this.emeraldStartTimer.Start()
		}

		if (this.titleSpriteAnim != null)
		{
			this.titleStartTimer.Start()
		}
	}

	// protected jpValues: JackpotValue2[] = [];
	// public UpdateValues(jackpotValues: JackpotValue2[]): void
	// {
	// 	this.jpValues = jackpotValues;
	// 	if (this.pauseJackpotValues) {
	// 		//console.log("IsJackpot");
	// 		return
	// 	}

	// 	let jp1: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == "jp1");
	// 	if (jp1 != null)
	// 	{
	// 		this.jackpotTextMapping[JackpotLevel.Jp1].SetTarget(jp1.CurrentMultipliedValue);
	// 	}

	// 	let jp2: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == "jp2");
	// 	if (jp2 != null)
	// 	{
	// 		this.jackpotTextMapping[JackpotLevel.Jp2].SetTarget(jp2.CurrentMultipliedValue);
	// 	}

	// 	let jp3: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == "jp3");
	// 	if (jp3 != null)
	// 	{
	// 		this.jackpotTextMapping[JackpotLevel.Jp3].SetTarget(jp3.CurrentMultipliedValue);
	// 	}

	// 	let jp4: JackpotValue2 = jackpotValues.find(jv => jv.JackpotLevel == "jp4");
	// 	if (jp4 != null)
	// 	{
	// 		this.jackpotTextMapping[JackpotLevel.Jp4].SetTarget(jp4.CurrentMultipliedValue);
	// 	}
	// }
	
	public TitleHide(){
		this.titleSpriteAnim.Hide();
		this.titleSpriteAnim.Stop();
	}
	public TitleShow(){
		this.titleSpriteAnim.Show();
		this.titleStartTimer.Start()
	}	

	// public Reset() {
	// 	console.log("Reset JackpotValues:");
	// 	this.jpValues.forEach((jp)=>{
	// 		console.log("JackpotValuesLevel:",jp.JackpotLevel , "ResetValue:",jp.ResetValue);
	// 	});	
	// }

	// public Resume() {				
	// 		console.log("Resume JackpotValues:");
	// 		this.pauseJackpotValues = false;
	// 		this.jpValues.forEach((jp)=>{
	// 			console.log("JackpotValuesLevel:",jp.JackpotLevel , "CurrentValue:",jp.CurrentValue);
	// 		});	
	// 		this.UpdateValues(this.jpValues);		
	// }

	// protected pauseJackpotValues = false;
	// public Pause() {				
	// 		console.log("Pause JackpotValues");
	// 		this.pauseJackpotValues = true;	
	// }
}
